module.exports = __webpack_public_path__ + "image/about_image_8_dfe88.png";